import React, { Component } from 'react'
import { Card, notification, Form, Tag, Popconfirm, Button } from 'antd'
import { connect } from 'react-redux'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils-lite'
import { DisplayDate } from '../../../components/_utils/appUtils'
import Request from '../../../request'
import { listSubmissionErrors,deleteSubmissionErrors } from '../actions'
@Form.create()
class RawSubmissions extends Component {
  state = {
    total: '',
    filters: {}
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let obj = { ...params, ...this.state.filters }
      let data = await listSubmissionErrors(obj)

      this.setState({ total: data.total })
      resolve(data)
    })
  }
  reload = () => {
    this.table.current.reload()
  }
  handleDelete = async (id) => {
    let resp = await deleteSubmissionErrors(id);
    if (resp && !resp.error) {
      this.reload();
    }
  }
  render() {
    const columns = [
      {
        title: 'Submission Date',
        key: 'intakeTimestamp',
        dataIndex: 'intakeTimestamp',
        render: (text, record) => record.intakeTimestamp ? DisplayDate(record.intakeTimestamp) : null
      },
      // {
      //   title: 'Status',
      //   key: 'status',
      //   dataIndex: 'status',
      //   render: (text, record) => (
      //     <Tag color={record.status === 'RECEIVED' ? 'green' : 'blue'}>{record.status}</Tag>
      //   )
      // },
      {
        title: 'Manuscript Title',
        key: 'titleOfAbstract',
        render: (text, record) => (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.titleOfAbstract : 'N/A'
      },
      {
        title: 'Absrtact',
        key: 'abstract',
        render: (text, record) => (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.abstract : 'N/A'
      },
      {
        title: 'Author',
        key: 'authorName',
        render: (text, record) => (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.authorName : 'N/A'
      },
      {
        title: 'Email',
        key: 'email',
        render: (text, record) => (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.email : 'N/A'
      },
      {
        title: 'Journal/Event',
        key: 'journal',
        render: (text, record) => (record && record.rawBody && record.rawBody.abstract) ? record.rawBody.abstract.journal : 'N/A'
      },
      {
        title: 'Actions',
        key: 'actions',
        width: 160,
        align: 'center',
        render: (text, record) => (
          <Popconfirm
            placement="bottom"
            title={`Are you sure you want to delete this Submission ?`}
            onConfirm={() => this.handleDelete(record._id)}
            okText='Yes' cancelText='No'
          >
            <Button className='roundSmallBtn2'>Delete</Button>
          </Popconfirm>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={`Submissions Errors (${this.state.total})`}>
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
          />
        </Card>
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({ categories: global.categories })
const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(RawSubmissions)